import { ApiNews } from "@/api/news";
import { useLocalizedQuery } from "@/hooks/locale/useLocalizeQuery/useLocalizeQuery";

export const useHomeData = () => {
  const { data: news, isLoading: newsLoading } = useLocalizedQuery({
    queryKey: ["news", 1],
    queryFn: async lang => ApiNews.getNews(lang, { pageNumber: 1 }),
    options: { select: data => data.data.slice(0, 4) },
  });

  return { news, newsLoading };
};
